let elements = {
  blockCheck: true,
  blockWrongColor: true,
  audio: {
    negative: 'games/page033_game1/audio/false.mp3',
    // positive: 'games/page033_game1/audio/true.mp3',
    click: 'games/page033_game1/audio/click.mp3',
  },
  image: {
    trImage: 'games/page033_game1/img/img_t.webp',
    srcImage: 'games/page033_game1/img/img_o.png',
    srcMask: 'games/page033_game1/img/img_m.png',
    width: 1920,
    height: 1080,
    colors: {
      1: '#000000',
      2: '#97ca4a',
      3: '#f47430',
      4: '#ee2a29',
      // 4: '#53bb3f',
      // 5: '#ea742f',
      // 6: '#05a6e2',
    },
    cssStyle: {
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '1080px',
      width: '1920px',
    },
  },
  palette: {
    colors: [
      {
        val: '#05a6e2', // blue
        audio: 'games/page033_game1/audio/10_blue.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/blue.png' },
        clicked: { src: 'games/page033_game1/img/blue_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '2.5%',
          top: '23.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#ee2a29', // red
        audio: 'games/page033_game1/audio/49_tomato.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/red.png' },
        clicked: { src: 'games/page033_game1/img/red_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '2.5%',
          top: '30.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#f2ea00', // yellow
        audio: 'games/page033_game1/audio/9_yellow.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/yellow.png' },
        clicked: { src: 'games/page033_game1/img/yellow_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '2.5%',
          top: '37.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#97ca4a', // green
        audio: 'games/page033_game1/audio/47_pepper.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/green.png' },
        clicked: { src: 'games/page033_game1/img/green_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '2.5%',
          top: '44.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#b604db', // purple
        audio: 'games/page033_game1/audio/12_purple.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/purple.png' },
        clicked: { src: 'games/page033_game1/img/purple_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '2.5%',
          top: '51.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#ff69c0', // pink
        audio: 'games/page033_game1/audio/13_pink.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/pink.png' },
        clicked: { src: 'games/page033_game1/img/pink_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '2.5%',
          top: '58.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
      {
        val: '#f47430', // orange
        audio: 'games/page033_game1/audio/48_carrot.mp3',
        waitingToBeClicked: { src: 'games/page033_game1/img/orange.png' },
        clicked: { src: 'games/page033_game1/img/orange_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '2.5%',
          top: '65.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
    ],
  },
  mbStaticAudioItemData: [
    {
      src: 'games/page033_game1/audio/47_pepper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page033_game1/img/audioOn.png', iconOff: 'games/page033_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 240,
        x: 835,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      src: 'games/page033_game1/audio/48_carrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page033_game1/img/audioOn.png', iconOff: 'games/page033_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 570,
        x: 850,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
    {
      src: 'games/page033_game1/audio/49_tomato.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page033_game1/img/audioOn.png', iconOff: 'games/page033_game1/img/audioOff.png' },
        fill: 'black',
      },
      pos: {
        y: 950,
        x: 845,
      },
      width: '50px',
      height: '50px',
      unit: 'px',
    },
  ],
};

export default elements;
